var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcListinRight = function SvgIcListinRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    fill: "none",
    viewBox: "0 0 18 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.322 5.223a1.1 1.1 0 0 0 0 1.555L14.545 12l-5.223 5.223a1.1 1.1 0 1 0 1.556 1.555l6-6a1.1 1.1 0 0 0 0-1.555l-6-6a1.1 1.1 0 0 0-1.556 0",
    clipRule: "evenodd"
  })));
};
export default SvgIcListinRight;